import {
	// atoms
	ButtonAnchorThemeControls,
	ButtonFilterThemeControls,
	ButtonPrimaryThemeControls,
	ButtonSecondaryThemeControls,
	HeadingThemeControls,
	IntroductionThemeControls,
	ListThemeControls,
	ParagraphThemeControls,
	QuoteThemeControls,
	TagThemeControls,

	// molecules
	AccordionThemeControls,
	AlertThemeControls,
	CardAddressThemeControls,
	CardCtaThemeControls,
	CardFeatureThemeControls,
	CardIconTextThemeControls,
	CardKeyfactTextThemeControls,
	CardKeyfactIconThemeControls,
	CardLogoThemeControls,
	CardNewsThemeControls,
	CardPartnerThemeControls,
	CardPeopleThemeControls,
	CardResourceThemeControls,
	CardCalendarThemeControls,
	CardDateTimeThemeControls,
	CardDateTourThemeControls,
	CardRoleThemeControls,
	CardArtistThemeControls,
	CardProductionThemeControls,
	CardSubscriptionThemeControls,
	CardShopThemeControls,
	FormThemeControls,
	GdprThemeControls,
	ImageThemeControls,
	VideoThemeControls,
	MediaThemeControls,
	ListCalendarThemeControls,
	ListShowsThemeControls,
	ListAccordionsThemeControls,
	ListNewsThemeControls,
	ListAddressThemeControls,
	ListButtonsThemeControls,
	ListButtonsAnchorThemeControls,
	ListCtasThemeControls,
	ListFeaturesThemeControls,
	ListIconTextThemeControls,
	ListKeyfactsIconThemeControls,
	ListKeyfactsTextThemeControls,
	ListLogosThemeControls,
	ListPeopleThemeControls,
	ListResourcesThemeControls,
	SliderThemeControls,
	ListFilesThemeControls,
	ListArtistsThemeControls,
	ListEventsThemeControls,
	ListHighlightedArtistsThemeControls,
	ListHighlightedProductionsThemeControls,
	ListPartnersThemeControls,
	FiltersThemeControls,
	ListProductionsThemeControls,
	ListShopThemeControls,

	// organisms
	CategoriesFilterThemeControls,
	PageHeaderThemeControls,
	PageHeaderSimpleThemeControls,
	PageHeaderTwoColumnsThemeControls,
	PaginationThemeControls,
	SectionButtonsAnchorThemeControls,
	FooterThemeControls,
	HeaderAThemeControls,
	HeaderBThemeControls,
	HeaderCThemeControls,
	HomeCalendarThemeControls,
	MainNavThemeControls,
	SectionDatesTimesThemeControls,
	SectionDatesTourThemeControls,
	SectionCtasThemeControls,
	SectionDetailsThemeControls,
	SectionFaqThemeControls,
	SectionRichContentThemeControls,
	SubsectionQuoteThemeControls,
	SubsectionCenteredTextThemeControls,
	SubsectionTwoImagesThemeControls,
	SubsectionBigTextImagesThemeControls,
	SubsectionGalleryThemeControls,
	SubsectionKeywordImageThemeControls,
	SubsectionTextMediaThemeControls,
	SubsectionLeadingArtistsThemeControls,
	SubsectionHeaderThemeControls,
	SectionDocumentationThemeControls,
	SectionPartnersThemeControls,
	SectionCardsArtistThemeControls,
	SectionCardsEventThemeControls,
	SectionHighlightedArtistsThemeControls,
	SectionHighlightedProductionsThemeControls,
	SectionCardsPressThemeControls,
	SectionPressSliderThemeControls,
	SectionArtistsSliderThemeControls,
	SectionCardsPartnerThemeControls,
	SectionMonthCalendarThemeControls,
	ResultsInfoThemeControls,
	SectionCardsProductionThemeControls,
	SectionSubscriptionThemeControls,
	SectionCardsShopThemeControls,
	GoogleSearchThemeControls,
	// -- GENERATOR CUSTOM BLOCKS IMPORT SLOT --
} from '@/components/themings';

// templates
import { SinglePageThemeControls } from '@/components/templates/SinglePage/theming';
import { CalendarPageThemeControls } from '@/components/templates/CalendarPage/theming';
import { EventsPageThemeControls } from '@/components/templates/EventsPage/theming';

export const blocksThemeControls = [
	// atoms
	ButtonAnchorThemeControls,
	ButtonFilterThemeControls,
	ButtonPrimaryThemeControls,
	ButtonSecondaryThemeControls,
	HeadingThemeControls,
	IntroductionThemeControls,
	ListThemeControls,
	ParagraphThemeControls,
	QuoteThemeControls,
	TagThemeControls,

	// molecules
	AccordionThemeControls,
	CardAddressThemeControls,
	CardCtaThemeControls,
	CardFeatureThemeControls,
	CardIconTextThemeControls,
	CardKeyfactTextThemeControls,
	CardKeyfactIconThemeControls,
	CardLogoThemeControls,
	CardNewsThemeControls,
	CardPartnerThemeControls,
	CardPeopleThemeControls,
	CardResourceThemeControls,
	FormThemeControls,
	GdprThemeControls,
	ImageThemeControls,
	VideoThemeControls,
	MediaThemeControls,
	ListAccordionsThemeControls,
	ListNewsThemeControls,
	ListAddressThemeControls,
	ListButtonsThemeControls,
	ListButtonsAnchorThemeControls,
	ListCtasThemeControls,
	ListFeaturesThemeControls,
	ListIconTextThemeControls,
	ListKeyfactsIconThemeControls,
	ListKeyfactsTextThemeControls,
	ListLogosThemeControls,
	ListPeopleThemeControls,
	ListResourcesThemeControls,
	SliderThemeControls,
	CardCalendarThemeControls,
	CardDateTimeThemeControls,
	CardDateTourThemeControls,

	ListCalendarThemeControls,
	ListShowsThemeControls,
	ListFilesThemeControls,
	ListArtistsThemeControls,
	ListEventsThemeControls,
	ListHighlightedArtistsThemeControls,
	ListHighlightedProductionsThemeControls,
	CardArtistThemeControls,
	CardPartnerThemeControls,
	ListPartnersThemeControls,
	FiltersThemeControls,
	AlertThemeControls,
	CardProductionThemeControls,
	ListProductionsThemeControls,
	CardSubscriptionThemeControls,
	CardShopThemeControls,
	ListShopThemeControls,

	// organisms
	CategoriesFilterThemeControls,
	PageHeaderThemeControls,
	PageHeaderSimpleThemeControls,
	PageHeaderTwoColumnsThemeControls,
	PaginationThemeControls,
	SectionButtonsAnchorThemeControls,
	FooterThemeControls,
	HeaderAThemeControls,
	HeaderBThemeControls,
	HeaderCThemeControls,
	HomeCalendarThemeControls,
	MainNavThemeControls,
	SectionRichContentThemeControls,
	SectionDatesTimesThemeControls,
	SectionDatesTourThemeControls,
	SectionFaqThemeControls,
	SectionCtasThemeControls,
	SectionDetailsThemeControls,
	SubsectionCenteredTextThemeControls,
	SubsectionQuoteThemeControls,
	SubsectionTwoImagesThemeControls,
	SubsectionBigTextImagesThemeControls,
	SubsectionGalleryThemeControls,
	SubsectionKeywordImageThemeControls,
	SubsectionTextMediaThemeControls,
	SubsectionLeadingArtistsThemeControls,
	CardRoleThemeControls,
	SubsectionHeaderThemeControls,
	SectionDocumentationThemeControls,
	SectionPartnersThemeControls,
	SectionCardsArtistThemeControls,
	SectionCardsEventThemeControls,
	SectionHighlightedArtistsThemeControls,
	SectionHighlightedProductionsThemeControls,
	SectionCardsPressThemeControls,
	SectionPressSliderThemeControls,
	SectionArtistsSliderThemeControls,
	SectionCardsPartnerThemeControls,
	SectionMonthCalendarThemeControls,
	ResultsInfoThemeControls,
	SectionCardsProductionThemeControls,
	SectionSubscriptionThemeControls,
	SectionCardsShopThemeControls,
	GoogleSearchThemeControls,
	// -- GENERATOR THEME CONTROLS SLOT --
];

export const templatesThemeControls = [
	// templates
	SinglePageThemeControls,
	CalendarPageThemeControls,
	EventsPageThemeControls,
];
